// extracted by mini-css-extract-plugin
export default {"fp-enter-email-content-wrapper":"fp-enter-email-content-wrapper-2504","send-reset-link-button":"send-reset-link-button-5042"};